<template>
  <v-container>
    <v-layout row v-if="error">
      <v-flex xs12 sm6 offset-sm3>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout row>
      <v-flex xs12>
        <v-card>
          <v-card-text>
            <v-container>
              <form @submit.prevent="onSave">
                <v-layout row>
                  <v-flex xs6>
                    <v-text-field
                    name="firstName"
                    label="First Name"
                    id="FirstName"
                    v-model="firstName"
                    type="text"
                    required></v-text-field>
                  </v-flex>
                  <v-flex xs6>
                    <v-text-field
                    name="lastName"
                    label="last Name"
                    id="lastName"
                    v-model="lastName"
                    type="text"
                    required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                    name="Email"
                    label="Email"
                    id="Email"
                    v-model="email"
                    type="text"
                    :disabled="$store.state.user.email !== undefined"
                    required></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12>
                    <v-text-field
                    name="collaboration key"
                    label="Collaboration Key"
                    id="CID"
                    v-model="cId"
                    type="text"
                    :disabled="$store.state.company.activeeeeeeeeeee"
                    ></v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12>
                    <v-select
                    label="Technical/Service Trade"
                    :items="services"
                    v-model="service"
                    ></v-select>
                  </v-flex>
                </v-layout>

               <!--  <v-layout row>
                  <v-flex xs12>
                    <v-btn class="primary" type="submit" :disabled="loading" :loading="loading">
                      Save Changes
                    </v-btn>
                  </v-flex>
                </v-layout> -->

              </form>
            </v-container>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data () {
    return {
      pickedColor: ''
    }
  },
  props: {

  },
  computed: {
    service: {
      set(service) {
        this.$store.commit('service', service)
      },
      get() {
        return this.$store.getters.user.service
      },
    },
    cId: {
      set(cId){
        this.$store.commit('cId', cId)
      },
      get(){
        return this.user.cId
      }
    },
    email: {
      set(id){
        this.$store.commit('email', id)
      },
      get(){
        return this.user.email
      }
    },
    firstName: {
      set(id){
        this.$store.commit('firstName', id)
      },
      get(){
        return this.user.firstName
      }
    },
    lastName: {
      set(id){
        this.$store.commit('lastName', id)
      },
      get(){
        return this.user.lastName
      }
    },
    services () {
      return this.$store.getters.services
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    }
  },
  watch: {
    
  },
  methods: {
    onSave () {
      this.$store.dispatch('validateKey', {cId: this.$store.getters.user, callBack: 'updateUser'})
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>
